module.exports = __webpack_public_path__ + "media/images/icons/arrow-left-ea88576787270a7d5a2ebec472165c2e.svg";